module.exports = __webpack_public_path__ + "img/style-light.5b0a7237.png";